module.exports = __webpack_public_path__ + "static/media/ios-cube.060b2c35.svg";